import { Component, Injectable, Input, Compiler } from '@angular/core';
import { NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { AlertService } from '../../../../../../app/utils/alert.service';
import { DataPackGroup } from '../../../../../../app/models/dataPackGroup.model';
import { DataPackLine } from '../../../../../../app/models/dataPackLine.model';

import { ConsumeService } from '../../../../../../app/services/consume.service';

/**
 * @version $Id: content.component.ts 63831 2017-09-23 17:42:15Z sandro.c.simas $
 */
@Component({
  selector: 'editNotifLines',
  templateUrl: './content.modal.template.html'
})
@Injectable()
export class EditNotifLinesComponent {

  @Input() selectedGroup: DataPackGroup;
  @Input() selectedLines: Map<string, DataPackLine>;

  private saving: boolean = false;

  constructor(private activeModal: NgbActiveModal, private consumeService: ConsumeService, private alertService: AlertService) {

  }

  private saveLines(notifyManagerGroup: boolean) {
    this.saving = true;
    let payload = {
      action: 'saveLines',
      sourceGroup: {
        id: this.selectedGroup.id
      },
      lines: []
    };
    this.selectedLines.forEach((line: DataPackLine) => {
      payload.lines.push({
        account: line.account,
        lineNumber: line.lineNumber,
        userName: line.userName,
        quota: line.quota,
        notifyManagerGroup: notifyManagerGroup
      });
    });
    this.consumeService.save(payload).subscribe(
      data => {
        this.alertService.success(data['result']);
        this.saving = false;
        this.activeModal.close();
      },
      err => {
        this.alertService.error(err.result, err);
        this.saving = false;
        this.activeModal.close();
      }
    );
  }

  private close() {
    this.activeModal.dismiss();
  }
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/consume/data/editNotifConsLines/content.component.ts